import { render } from "./TrashedPersonCard.vue?vue&type=template&id=5017595a&scoped=true&ts=true"
import script from "./TrashedPersonCard.vue?vue&type=script&lang=ts"
export * from "./TrashedPersonCard.vue?vue&type=script&lang=ts"

import "./TrashedPersonCard.vue?vue&type=style&index=0&id=5017595a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5017595a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QAvatar,QImg,QIcon,QCardSection,QCardActions,QBtn,QTooltip});
